<button [disabled]="disabled" odxButton variant="primary" (click)="clickAdd()" draggable="true" (dragstart)="onDragStart()">
  <odx-icon name="plus" variant="primary" size="medium"></odx-icon>
</button>
